"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debug = debug;
exports.isDefined = isDefined;
exports.toSnakeCase = toSnakeCase;
exports.toCamelCase = toCamelCase;
exports.isObject = isObject;
exports.objectToCamelCase = objectToCamelCase;
exports.objectToSnakeCase = objectToSnakeCase;
exports.debounce = debounce;
exports.sortAlphabetically = sortAlphabetically;
exports.getSubdomain = getSubdomain;
exports.textToKabobCase = textToKabobCase;
exports.formatNumberAsUSD = formatNumberAsUSD;
exports.formatDateShort = formatDateShort;
exports.urlQueryParams = urlQueryParams;
exports.getCookie = getCookie;
Object.defineProperty(exports, "random", {
  enumerable: true,
  get: function get() {
    return _random["default"];
  }
});
exports["default"] = void 0;

var _random = _interopRequireDefault(require("./random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Main Module
var Utils = {
  // Local Functions
  debug: debug,
  toSnakeCase: toSnakeCase,
  toCamelCase: toCamelCase,
  objectToCamelCase: objectToCamelCase,
  objectToSnakeCase: objectToSnakeCase,
  isObject: isObject,
  isDefined: isDefined,
  formatNumberAsUSD: formatNumberAsUSD,
  formatDateShort: formatDateShort,
  textToKabobCase: textToKabobCase,
  getSubdomain: getSubdomain,
  urlQueryParams: urlQueryParams
};
var _default = Utils; // Sub-Modules

exports["default"] = _default;

/**
 * Console log only if VUE_DEBUG is set to True in environment.
 */
function debug() {
  if (process.env.VUE_APP_DEBUG === "true") {
    var _console;

    // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, arguments);
  }
}
/**
 * True/False, the given value is defined.
 **/


function isDefined(value) {
  return typeof value !== "undefined";
}
/**
 * Transform a string value from `camelCase` style notation to `snake_case` notation.
 *
 * This is useful for translating Python-serialized JSON objects to JavaScript objects.
 */


function toSnakeCase(value) {
  var upperChars = value.match(/([A-Z])/g);

  if (!upperChars) {
    return value;
  }

  var str = value.toString();

  for (var i = 0, n = upperChars.length; i < n; i++) {
    str = str.replace(new RegExp(upperChars[i]), "_" + upperChars[i].toLowerCase());
  }

  if (str.slice(0, 1) === "_") {
    str = str.slice(1);
  }

  return str;
}
/**
 * Transform a string value from `snake_case` style notation to `camelCase` notation.
 *
 * This is useful for translating Python-serialized JSON objects to JavaScript objects.
 *
 * @param {String} value - The string value to transform.
 */


function toCamelCase(value) {
  if (value === value.toUpperCase()) return value;
  return value.split("_").map(function (word, index) {
    // Do nothing with the first word
    if (index === 0) {
      return word;
    } // If it is not the first word only upper case the first char and lowercase the rest.


    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join("");
}
/**
 * Check whether a value is an Object.
 */


function isObject(value) {
  return value !== null && value instanceof Object && !Array.isArray(value);
}
/**
 * Transform the string-based keys of a JavaScript object to `camelCase` style notation.
 *
 * This is useful for translating the style of object keys after making an API call to
 * the Python-based API, which uses `snake_case` style notation by default.
 */


function objectToCamelCase(value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (acc, snakeKey) {
      var camelKey = toCamelCase(snakeKey);
      acc[camelKey] = isObject(value[snakeKey]) ? objectToCamelCase(value[snakeKey]) : value[snakeKey];
      return acc;
    }, {});
  }
}
/**
 * Transform the string-based keys of a JavaScript object to `snake_case` style notation.
 *
 * This is useful for translating the `camelCase` style of JavaScript keys BEFORE posting
 * the data to the Python-based API, which uses `snake_case` style notation by default.
 */


function objectToSnakeCase(value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (acc, camelKey) {
      var snakeKey = toSnakeCase(camelKey);
      acc[snakeKey] = isObject(value[camelKey]) ? objectToSnakeCase(value[camelKey]) : value[camelKey];
      return acc;
    }, {});
  }
}
/**
 * For a repeatedly-called function, delay until x milliseconds after the last call.
 *
 * Use this when handling user input events that occur in
 * rapid succession, ex: typing into a "typeahead" component.
 *
 * @param {function} callback - The function to delay.
 * @param {Number}   time     - Delay time in milliseconds.
 *
 * @returns {Function}
 */


function debounce(callback, time) {
  var timer = null;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var onComplete = function onComplete() {
      callback.apply(_this, args);
      timer = null;
    };

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(onComplete, time);
  };
}
/**
 * Sort an array of Objects alphabetically by a given property
 *
 * @param {Array}  arr       - The array to be sorted.
 * @param {String} property  - The object property to sort on.
 * @param {String} exception - Property value to exclude from sorting.
 */


function sortAlphabetically(arr, property) {
  var exception = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  arr.sort(function (a, b) {
    if (a[property] !== exception && b[property] !== exception) {
      var textA = a[property].toUpperCase();
      var textB = b[property].toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    }
  });
  return arr;
}
/**
 * Parses the subdomain from `window.location.hostname`.
 */


function getSubdomain() {
  var hostnameArr = window.location.hostname.split(".");
  return hostnameArr.length === 3 ? hostnameArr[0] : "n/a";
}
/**
 * Convert a string to "kabob case."
 *
 * ex: 'Financial Health' -> 'financial-health'
 *
 * @param {String} text - The string to convert.
 **/


function textToKabobCase(text) {
  return text.toLowerCase().replace(" ", "-");
}
/**
 * Format a number as US Dollars
 *
 * ex: 400 -> "$400.00"
 *
 * @param {String, Number} value - The value to format as US Dollars
 */


function formatNumberAsUSD(value) {
  // Ignore falsey values, except zero, because zero dollars is OK!
  if (value !== 0 && !value) return "";
  return Number(value).toLocaleString("en", {
    style: "currency",
    currency: "USD"
  });
}
/**
 * Format a Date string or object.
 *
 * Returns 'N/A' if a falsey value is given.
 *
 * @param {String, Date} value - The date string or object to format.
 */


function formatDateShort(value) {
  if (!value) return "N/A";
  var date = new Date(value);
  return date.toLocaleDateString(["en-US"], {
    month: "short",
    day: "2-digit",
    year: "numeric"
  });
}
/**
 * Looks to the current URL and produces a dictionary with keys as paramName and values as paramValue.
 *
 * For example, URL of 'https://example.com?one=uno,two=dos'
 *
 * Yields an output of
 *
 * { one: 'uno', two: 'dos' }
 **/


function urlQueryParams() {
  var params = new URLSearchParams(window.location.search);
  var output = {};

  var _iterator = _createForOfIteratorHelper(params.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var e = _step.value;
      output[e[0]] = e[1];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return output;
}
/*
 * getCookie
 *
 * Use this method for getting cookie values (i.e. for getting the CSRF token).
 *
 * @param {String} cname - the name of the cookie you'd like the value of.
 *
 * Usage:
 *   const csrfToken = getCookie("csrftoken");
 */


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}